module.exports = __webpack_public_path__ + "img/laboGrey.f4b6dda2.svg";